import {z} from 'zod';
import paginatedSchema from "../common/paginatedSchema";
import {clubSchema} from "../club/clubSchema";
import {categoryShortSchema} from "../category/categoriesSchema";

const boatSchema = z.object({
    id: z.number(),
    name: z.string()
        .min(1, "Jméno nemůže být prázdné")
        .max(50, "Jméno může mít maximálně 50 znaků"),
    boatNumber: z.string()
        .max(50, "Číslo lodi může mít maximálně 50 znaků")
        .optional().nullable(),
    sailNumber: z.string()
        .max(50, "Číslo na plachtě může mít maximálně 50 znaků")
        .optional().nullable(),
    raceNumber: z.number({
        required_error: "Závodní číslo je povinné",
        invalid_type_error: "Závodní číslo musí být platné číslo",
    })
        .positive("Závodní číslo musí být kladné")
        .int("Závodní číslo musí být celé číslo")
        .optional().nullable(),
    color: z.string()
        .max(50, "Barva může mít maximálně 50 znaků")
        .optional().nullable(),
    type: z.string()
        .max(50, "Typ může mít maximálně 50 znaků")
        .optional().nullable(),
    length: z.number({
        required_error: "Délka je povinné",
        invalid_type_error: "Délka musí být platné číslo",
    })
        .positive("Délka musí být kladná")
        .optional().nullable(),
    club: clubSchema
        .optional().nullable(),
    category: categoryShortSchema,
    officialRegistered: z.boolean(),
    registrarId: z.number(),
});

const paginatedBoatsSchema = paginatedSchema(boatSchema);

type Boat = z.infer<typeof boatSchema>;
type PaginatedBoats = z.infer<typeof paginatedBoatsSchema>;

export {boatSchema, paginatedBoatsSchema, type Boat, type PaginatedBoats};
